import { useSelector } from "react-redux";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAppDispatch } from "../../../../../hooks/hooks";
import { selectListItems } from "../../../../../redux/library/selector";
import { selectEDocsListItems } from "../../../../../redux/e-docs/selector";
import { eDocs } from "../../../../../redux/e-docs/action";
import PageLoader from "../../../../../components/PageLoader";
import Table from "../../../../../common/components/table";


const ManagementEDocs = () => {
	const dispatch = useAppDispatch()
  const libraryData = useSelector(selectListItems)
  const navigate = useNavigate()
  const [pageData, setPageData] = useState(1)
    const eDocsItems = useSelector(selectEDocsListItems)
    const [
        columnDefs,
        setColumnDefs
      ] = useState({});
      const createColumnDefs: any = () => {
        setColumnDefs([
          {
            field: 'Sl',
            sortable: false,
            filter: false,
            isSortLabel: true,
            headerName: 'Sl',
            cellRenderer (params: any) {
              return parseInt(
                params.node.id,
                10
              ) + 1;
            },
          },
          {
            field: 'Type', headerName: 'View', sortable: false, filter: false, cellRenderer: 'viewRenderer'
          },
          {
            field: 'Url', headerName: 'Copy Url', sortable: false, filter: false, cellRenderer: 'copyRenderer'
          },
          { field: 'Name', headerName: 'Name', sortable: false, filter: false },
          { field: 'DateCreated', headerName: 'Date Created', isDateValueFormat:true, sortable: true },
          { field: 'DateModified', headerName: 'Date Modified', isDateValueFormat:true, sortable: true }
        ]);
      }
    
  const fetcheDocs=()=>{
    dispatch(eDocs.list({url:`https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/cms/e-docs/list`,entity:'eDocs',jsonData:{
  
    "PageNumber": pageData,
    "PageSize": 10,
    "SortField": "Id",
    "SortOrder": "desc",
    

    }}))
  }
  const handleEdit=(data: any)=>{
    navigate(`${data?.Id}`)
  }
useEffect(() => {
    createColumnDefs()
    fetcheDocs()
}, [pageData])

return (
<>
{eDocsItems?.isLoading ?  <PageLoader />: 
<Table columnData={columnDefs} rowData={eDocsItems?.result?.items} setPageData={setPageData} isEdocs
paginationData={eDocsItems?.result?.pagination} onEdit={handleEdit} headingName="E Docs"/>
 
}
</> 
);
};

export default ManagementEDocs;


